export default __webpack_public_path__ + "static/media/501.b302983e.jpg";